export default __webpack_public_path__ + "static/media/cal_bg8.ddfc9518.jpg";